import React from 'react';

import Link, { LinkProps } from 'next/link';
import { useRouter } from 'next/router';

import { EmptyState, Text } from '@morressier/ts';

import { Grid, useMediaQuery, useTheme } from '@material-ui/core';
import { FaChalkboardTeacher } from 'react-icons/fa';

import { BlockedComponentType } from 'components/EventStandardContainer';
import Paging from 'components/Paging';
import { PageProps } from 'pages/event/[eventId]/exhibitors/page/[page]';
import { logEvent } from 'utils/eventTracking';
import { commaFormat } from 'utils/numberFormatter';

import * as ContainerStyles from '../styles';
import { ExhibitorItem } from './ExhibitorItem';

export const ExhibitorsList: React.FC<PageProps['data']> & BlockedComponentType = props => {
  const { query, pathname } = useRouter();
  const { total, exhibitors, pageSize, event } = props;
  const eventId = event.id;

  const { page = 1 } = query as {
    eventId: string;
    page: string;
  };

  const pageRouteBuilder = (pageNumber: number): LinkProps['href'] => ({
    pathname,
    query: { ...query, page: pageNumber },
  });

  const theme = useTheme();
  const isBelowLg = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <ContainerStyles.PageContainer withTopMargin>
      <ContainerStyles.PageTitle>Exhibitors</ContainerStyles.PageTitle>

      <Text color="grey" style={{ marginBottom: isBelowLg ? '1rem' : '2rem' }}>
        {commaFormat(total)} {total === 1 ? 'exhibitor' : 'exhibitors'}
      </Text>

      <Grid container spacing={isBelowLg ? 2 : 4} style={{ marginBottom: '24px' }}>
        {exhibitors.length ? (
          exhibitors.map(data => (
            <Grid key={data._id} xs={12} sm={6} lg={4} item>
              <Link key={data._id} href={`/event/${eventId}/exhibitors/${data._id}`}>
                <a style={{ textDecoration: 'none', display: 'flex', height: '100%' }}>
                  <ExhibitorItem
                    data={data}
                    onClick={() => {
                      logEvent('CLICKED_EXHIBITOR_PAGE', {
                        eventId,
                        exhibitorId: data._id,
                      });
                    }}
                  />
                </a>
              </Link>
            </Grid>
          ))
        ) : (
          <Grid xs={12} style={{ margin: '5rem 0 15rem 0' }} item>
            <EmptyState
              title="No exhibitors have been announced yet"
              icon={<FaChalkboardTeacher size="70px" color="lightGrey" />}
            />
          </Grid>
        )}
      </Grid>

      {total ? (
        <Paging
          currentPage={Number(page)}
          totalPages={Math.ceil(total / pageSize)}
          pageRouteBuilder={pageRouteBuilder}
        />
      ) : null}
    </ContainerStyles.PageContainer>
  );
};

ExhibitorsList.disableEmbargoedPageBlock = true;
